import classNames from 'classnames';
import { BodyM } from 'components/Typography/Typography';
import React, { ReactElement } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/accordionContentStyle';
import { Icon, makeStyles } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';

// @ts-ignore
const useStyles = makeStyles(styles);

interface INoteProps {
	text?: string;
	Icon?: ReactElement;
	removeSpace?: boolean;
}

const Note = ({ text = '', Icon, removeSpace = false }: INoteProps) => {
	const classes = useStyles();
	return (
		<div
			className={classNames({
				[classes.singleAccordionRow]: true,
				[classes.bottomRow]: true,
				[classes.noteContent]: true,
				[classes.singleAccordionRowSpaceEvenly]: true,
				[classes.removeSpace]: !!removeSpace,
			})}
		>
			{Icon ? Icon : <InfoOutlined className={classes.secondaryBrand} />}
			<div>
				<BodyM disableMargin color="brand-secondary">
					<> {text}</>
				</BodyM>
			</div>
		</div>
	);
};

export default Note;
